export default __webpack_public_path__ + "static/media/训宠师勋章@2x.4e294f3a.png";